import storage from "redux-persist/es/storage";
import { ITokenPayload, IUser } from "../../models/user";
import { jwtDecode } from "jwt-decode";

export const USER_TOKEN_KEY = "token";
export const USER_ROLE_KEY = "role";
export const USER_FCM_TOKEN_KEY = "fcm_token";
export const USER_KEY = "user";

const getExpiryEpoch = (seconds: number) => {
  var t = new Date();
  t.setSeconds(t.getSeconds() + seconds);
  return t.getSeconds();
};

const storeToken = async (token: string) => {
  await storage.setItem(USER_TOKEN_KEY, token);
};
const storeRole = async (role: string) => {
  await storage.setItem(USER_ROLE_KEY, role);
};
const storeFcmToken = async (token: string) => {
  await storage.setItem(USER_FCM_TOKEN_KEY, token);
};

const getAccessToken = async () => {
  const tokenString = await storage.getItem(USER_TOKEN_KEY);

  return tokenString;
};

const clear = async () => {
  await storage.removeItem(USER_TOKEN_KEY);
  await storage.removeItem(USER_KEY);
  await storage.removeItem(USER_FCM_TOKEN_KEY);
};

const hasValidToken = async () => {
  const tokenString = await storage.getItem(USER_TOKEN_KEY);
  return Boolean(tokenString);
};

const storeUser = async (user: IUser) => {
  await storage.setItem(USER_KEY, JSON.stringify(user));
};

const getUser = async () => {
  const token = localStorage.getItem("token");

  if (
    !token ||
    token === "null" ||
    token === "undefined" ||
    token.trim() === ""
  ) {
    const tokenPayload: ITokenPayload = {
      fullName: "",
      avatar: "",
      email: "",
      createdAt: "",
      userId: "",
      isAdmin: false,
    };

    return tokenPayload;
  }

  const user = token && jwtDecode<ITokenPayload>(token);

  return user;
};

const authTokens = {
  getExpiryEpoch,
  storeToken,
  getAccessToken,
  hasValidToken,
  clear,
  storeUser,
  getUser,
  storeRole,
  storeFcmToken,
};

export default authTokens;
